import { GridCustomCellProps } from "@progress/kendo-react-grid";

const PhoneCellAndExtension = (props: GridCustomCellProps) => {
  if (!props.field || props.rowType !== 'data') return null;

  const phoneNumber = props.dataItem.PhoneNumber;
  const ext = props.dataItem.PhoneNumberExtension;

  return (
    <td {...props.tdProps}>
      <a href={`tel:${phoneNumber}`} className="text-primary">{phoneNumber}{ext && ` x${ext}`}</a>
    </td>
  );
}

export default PhoneCellAndExtension;